var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldLockSlash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 17.35c-.64 0-1.19-.37-1.45-.9l2.18-2.18c.53.26.9.81.9 1.45 0 .9-.73 1.63-1.63 1.63z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.681 2.23-2.81 2.81c-.77-2.02-2.74-3.04-5.87-3.04-5.63 0-6.28 3.58-6.28 6.28v1.25h.03c-2.83.34-3.75 1.75-3.75 5.26v1.86c0 1.6.19 2.76.67 3.59l-.45.45c-.3.3-.3.79 0 1.09.16.14.35.22.55.22.2 0 .39-.08.54-.23l18.46-18.46c.31-.3.31-.78 0-1.08-.3-.3-.79-.3-1.09 0zM7.121 9.44V8.28c0-2.93.83-4.88 4.88-4.88 3.4 0 4.47 1.3 4.77 2.75l-3.29 3.29h-6.36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 16.649c0 4.1-1.25 5.35-5.35 5.35H7.41c-.89 0-1.33-1.08-.7-1.71l2.82-2.82c.07.1.15.19.23.28.7.76 1.74 1.16 2.89.92.09-.02.18-.04.27-.08.09-.02.17-.05.25-.09.2-.07.39-.18.57-.31.07-.04.13-.09.18-.14.15-.12.29-.26.41-.41.05-.05.1-.11.14-.18.13-.18.24-.37.31-.57.04-.08.07-.16.09-.25.04-.09.06-.18.08-.27.24-1.15-.16-2.19-.92-2.89-.08-.08-.18-.16-.28-.23l3.12-3.12c.05-.05.09-.09.14-.13.4-.33.91-.49 1.42-.45.09.01.19.02.28.04.17.03.34.07.5.11.16.04.31.09.46.14.29.11.54.24.77.39.23.15.42.33.6.54.09.11.18.23.25.36.07.11.13.23.19.36.06.13.11.27.16.41.06.17.11.36.15.56.04.14.06.29.09.45.02.15.04.31.06.48.04.42.06.89.06 1.4v1.86z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldLockSlash);
export default __webpack_public_path__ + "static/media/vuesax-bold-lock-slash.893b622844f8d5dd43513662a42bfdab.svg";
export { ForwardRef as ReactComponent };